import CreateNotificationDialog from "./components/CreateNotificationDialog";
import NotificationPanel from "./components/NotificationPanel";
import NotificationList from "./components/list";

/**
 * Main notifications page component that displays a full-page notification list
 * with filtering and infinite scroll capabilities.
 */
const NotificationsPage = () => {
    return (
        <NotificationPanel>
            <div className="h-full container mx-auto w-full">
                <NotificationList dense={false} filterSize="medium" maxHeight={"80vh"} className="w-full" />
            </div>
            <CreateNotificationDialog />
        </NotificationPanel>
    );
};

export default NotificationsPage;
